<div class="wrapper">
    <mat-card class="form-card text-center bg-white mat-elevation-z3">
        <form [formGroup]="registerForm">
            <app-auth-top [title]="'Rejestracja'"
                          [subTitle]="'Wypełni formularz by utworzyć konto'"
                          [closeLink]="'/auth/login'"></app-auth-top>
            <mat-card-content>
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Twoje imię lub pseudonim</mat-label>
                    <input matInput formControlName="name" name="name" type="text" placeholder="Imię lub pseudonim"
                           #displayName>
                    <mat-hint align="end">
                        {{ displayName.value.length }} / {{ userNameMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="name.errors?.['required']">
                        Napisz imię lub pseudonim.
                    </mat-error>
                    <mat-error *ngIf="name.value.length < userNameMinLength && !name.errors?.['required']">
                        Minimalna długość wynosi {{ userNameMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="name.value.length > userNameMaxLength">
                        Maksymalna długość wynosi {{ userNameMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Nazwa firmy</mat-label>
                    <input matInput formControlName="company_name" name="company_name" type="text"
                           placeholder="Nazwa firmy"
                           #companyName>
                    <mat-hint align="end">
                        {{ companyName.value.length }} / {{ companyNameMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="company_name.errors?.['required']">
                        Napisz nazwę firmy lub organizacji.
                    </mat-error>
                    <mat-error
                        *ngIf="company_name.value.length < companyNameMinLength && !company_name.errors?.['required']">
                        Minimalna długość wynosi {{ companyNameMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="company_name.value.length > companyNameMaxLength">
                        Maksymalna długość wynosi {{ companyNameMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width pt-1" appearance="outline">
                    <mat-label>e-mail</mat-label>
                    <input matInput formControlName="email" name="email" type="email" placeholder="e-mail"
                           #emailAddress>
                    <mat-hint align="end">
                        {{ emailAddress.value.length }} / {{ emailMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="email.errors?.['email'] || email.errors?.['required']">
                        Wpisz poprawny adres e-mail.
                    </mat-error>
                    <mat-error *ngIf="emailAddress.value.length > emailMaxLength && !email.errors?.['email']">
                        Maksymalna długość wynosi {{ emailMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width pt-1" appearance="outline">
                    <mat-label>hasło</mat-label>
                    <input matInput formControlName="password" name="password" type="password" placeholder="hasło"
                           #passwd>
                    <mat-hint align="end">
                        {{ passwd.value.length }} / {{ passwordMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="password.errors?.['required']">
                        Podaj hasło.
                    </mat-error>
                    <mat-error *ngIf="passwd.value.length < passwordMinLength && !password.errors?.['required']">
                        Minimalna długość wynosi {{ passwordMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="passwd.value.length > passwordMaxLength">
                        Maksymalna długość wynosi {{ passwordMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width pt-1" appearance="outline">
                    <mat-label>ponów hasło</mat-label>
                    <input matInput formControlName="password_confirmation" name="password_confirmation" type="password"
                           placeholder="ponów hasło">
                    <mat-error *ngIf="password_confirmation.errors?.['required']">
                        Podaj hasło ponownie.
                    </mat-error>
                    <mat-error
                        *ngIf="password_confirmation.errors?.['confirmedValidator'] || password_confirmation.errors?.['touched']">
                        Hasło oraz ponowienie hasła muszą się zgadzać.
                    </mat-error>
                </mat-form-field>
                <mat-checkbox formControlName="regulations" color="primary">
                    Akceptuję <a class="link-secondary" routerLink="/regulations"
                                 matTooltip="Link do strony regulaminu" matTooltipPosition="right">regulamin</a>
                </mat-checkbox>
                <div class="pt-3">
                    <button type="button" class="full-width" mat-stroked-button color="primary"
                            [disabled]="isSaved || registerForm.invalid"
                            matTooltip="Rejestracja konta" matTooltipPosition="above" (click)="register()">
                        Rejestracja <i class="fa-solid fa-pen-to-square"></i></button>
                </div>
            </mat-card-content>
            <div class="py-4">
                <span>Jeżeli masz już konto to przejdź do: </span>
                <a class="link-secondary" routerLink="/auth/login"
                   matTooltip="Powrót do strony logowania" matTooltipPosition="right">logowania</a><span>.</span>
            </div>
        </form>
    </mat-card>
    <div class="mt-2">
        <app-company-link></app-company-link>
    </div>
</div>
